import { render, staticRenderFns } from "./BaseSearchModal.vue?vue&type=template&id=64db416a&scoped=true&"
import script from "./BaseSearchModal.vue?vue&type=script&lang=ts&"
export * from "./BaseSearchModal.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSearchModal.vue?vue&type=style&index=0&id=64db416a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db416a",
  null
  
)

export default component.exports